import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css'; 

const CreateProject = ({ user }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('Technology');
  const [image, setImage] = useState(null);
  const [projectCode, setProjectCode] = useState('');

  useEffect(() => {
    generateRandomCode();
  }, []);

  const generateRandomCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setProjectCode(result);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('category', category);
    formData.append('code', projectCode);
    formData.append('creator_id', user?.id);
    formData.append('projectImage', image);

    try {
      await axios.post('http://localhost:5000/api/projects/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      
      // Optional: Reset form and generate new code for next project
      setName('');
      setDescription('');
      setImage(null);
      generateRandomCode(); 
    } catch (err) {
      console.error(err);
      alert('Error creating project');
    }
  };

  return (
    <div className="glass-panel create-project-view">
        <div className="page-header create-project-header">
            <h2>Create New Project</h2>
            <p className="project-code-display">Project Code: <span className="code-highlight">{projectCode}</span></p>
        </div>

        <form onSubmit={handleSubmit} className="project-form">
            
            <div className="form-group form-group-name half">
                <label>Project Name</label>
                <input 
                    type="text" 
                    value={name}
                    placeholder="Enter name" 
                    onChange={(e) => setName(e.target.value)} 
                    required 
                />
            </div>

            <div className="form-group form-group-category half">
                <label>Category</label>
                <select className = "category" value={category} onChange={(e) => setCategory(e.target.value)} required>
                    <option value="Technology">Technology</option>
                    <option value="Art">Art</option>
                    <option value="Music">Music</option>
                    <option value="Gaming">Gaming</option>
                    <option value="Social Impact">Social Impact</option>
                    <option value="Business">Business</option>
                    <option value="Literature">Literature</option>
                    <option value="Content Creation">Content Creation</option>
                </select>
            </div>

            <div className="form-group full">
                <label>Description</label>
                <textarea 
                    value={description}
                    placeholder="Provide a brief overview..." 
                    onChange={(e) => setDescription(e.target.value)} 
                />
            </div>

            <div className="form-group full">
                <label>Project Cover Image</label>
                <label htmlFor="file-upload" className="file-upload-box">
                    <span>
                        {image ? `Selected: ${image.name}` : "Click to upload project image"}
                    </span>
                    <input 
                        id="file-upload"
                        type="file" 
                        accept="image/*" 
                        onChange={(e) => setImage(e.target.files[0])} 
                        style={{ display: 'none' }}
                        required 
                    />
                </label>
            </div>

            <button type="submit" className="project-submit-btn">
                Create Project 
            </button>
        </form>
    </div>
  );
};

export default CreateProject;